import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import update from 'immutability-helper';

import './Logged.scss';

import logo from '../../Assets/Images/ebs-logo-small.png';

import Header from '../../Components/Header/Header';
// import HeaderMobile from '../../Components/Header/HeaderMobile';
import Home from '../../Containers/Home/Home';
import Usuario from '../../Utils/Usuario';
import PermissaoNegada from '../../Utils/Permissao-Negada';
import { Permissions } from '../../Utils/Permissions';
import Authorization from '../../Utils/Authorization';
import SideBar from '../../Components/SideBar/SideBar';
import OrdersList from '../Orders/Orders-List';
import ClientOrders from '../Orders/Client-Orders';
import OrderDetails from '../Orders/Order-Details';
import LocationList from '../Logistics/Location-List';
// import LocationDetails from '../Logistics/Location-Details';
import NewLocation from '../Logistics/New-Location';
import EditionList from '../Content/Edition-List';
import ContentEditionList from '../Content/Content-Edition-List';
import ContentEditionDetails from '../Content/Content-Edition-Details';
import ArticleDetails from '../Content/Article-Details';
import EditionDetails from '../Content/Edition-Details';
import VideosProgramsList from '../Content/Videos/Videos-Programs-List';
import UsersList from '../Users/Users-List';
import NewOrder from '../Orders/New-Order';
import ChangePassword from '../Users/Change-Password';
import ProductList from '../Products/Product-List';
import ProductDetails from '../Products/Product-Details';
import SingleOrders from '../Orders/Single-Orders';
import CarriersList from '../Logistics/Carriers-List';
import ShippingList from '../Logistics/Shipping-List';
import NewShipping from '../Logistics/New-Shipping';
import ShippingDetails from '../Logistics/Shipping-Details';
import ListaAtendimentos from '../Assistance/Assistance-List';
import NovoAtendimento from '../Assistance/New-Assistance';
// import MenuAtendimento from '../../Components/Quick-Access-Menu/Assistance-Menu';
// import MenuPedido from '../../Components/Quick-Access-Menu/Order-Menu';
// import { Consumer } from '../../Context/Context-Menu-Acesso-Rapido/Context-Menu-Acesso-Rapido';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import VideosProgramDetails from '../Content/Videos/Videos-Program-Details';
import VideosEpisodeDetails from '../Content/Videos/Videos-Episode-Details';
import PhrasesList from "../../Containers/Phrase-of-the-Day/Phrases-List";
import PhraseDetails from "../../Containers/Phrase-of-the-Day/Phrase-Details";
import BillingErrorList from '../Billing/Billing-Error-List';
import BillingProcessedList from '../Billing/Billing-Processed-List';
import AreasList from '../Content/Special-Areas/Areas-List';
import AreaDetails from '../Content/Special-Areas/Area-Details';
import PodcastProgramsList from '../Content/Podcast/Podcast-Programs-List';
import PodcastProgramsDetails from '../Content/Podcast/Podcast-Program-Details';
import PodcastEpisodeDetails from '../Content/Podcast/Podcast-Episode-Details';
import Nominal from '../Reports/Orders/Nominal';
import PeriodicalCoordinators from '../Periodical-Coordinators/Periodical-Coordinators';
import PushTest from '../../Containers/Notifications/Push-Test';
import CampaignsList from '../../Containers/Campaigns/Campaigns-List';
import CampaignCreate from '../../Containers/Campaigns/Campaign-Create';
import HighLights from '../Content/HighLights/HighLights';
import AdvertisingList from '../Advertising/Advertising-List';
import AdvertisingDetails from '../Advertising/Advertising-Details';
import ForeignersList from '../Foreigners/Foreigners-List';
import ForeignersDetails from '../Foreigners/Foreigners-Details';
import MenuMobile from '../../Components/Menu-Mobile/Menu-Mobile';
import UserBalanceDetails from '../../Containers/User-Balance/User-Balance-Details';
import PeriodicalHighlights from '../../Containers/Periodical-Highlights/Periodical-Highlights';
import CileOrdersList from '../Cile/Cile-Orders-List';
//import Kpis from '../Kpis/Kpis';
import LocationInfo from '../../Components/Location-Info/Location-Info';
import LocationInfoOrganizations from '../Logistics/Location-Info-Organizations';
import LocationInfoClients from '../Logistics/Location-Info-Clients';
import CileShipping from '../Cile/Cile-Shipping';
import CileShippingDetails from '../Cile/Cile-Shipping-Details';
import ShippingDispatch from '../Logistics/Shipping-Dispatch';
import EditionsListRegister from '../../Components/Editions-List-Register/Editions-List-Register';
import CileExecutiveReport from '../Cile/Cile-Executive-Report/Cile-Executive-Report';
import NotScriptedList from '../Logistics/NotScripted-List';
// import ShippingDetailsCorreioIndividual from '../Logistics/Shipping-Details-CorreioIndividual';
import Unification from '../Unification/Unification';
import CileContent from '../Cile/Cile-Content/Cile-Content';
import CileContentBanners from '../Cile/Cile-Content/Cile-Content-Banners';
import CileContentVideos from '../Cile/Cile-Content/Cile-Content-Videos';
import CileContentReview from '../Cile/Cile-Content/Cile-Content-Review';
import CileContentBannersDetails from '../Cile/Cile-Content/Cile-Content-Banners-Details';
import CileContentReviewDetails from '../Cile/Cile-Content/Cile-Content-Review-Details';
import CileContentVideosDetails from '../Cile/Cile-Content/Cile-Content-Videos-Details';
import CileBetalabsFila from '../Cile/Cile-Betalabs/Cile-Betalabs-Fila';
import CileBetalabsFilaDetails from '../Cile/Cile-Betalabs/Cile-Betalabs-Fila-Details';
import AnswerList from '../Quick-Answer/Answer-List';
import AnswerDetails from '../Quick-Answer/Answer-Datails';
import NewAnswer from '../Quick-Answer/New-Answer';
import Banners from '../Content/Banners';
import BannerDetails from '../Content/Banner-Details';
import SearchList from '../Search/Search-List';
import SearchDatails from '../Search/Search-Datails';
import SearchResults from '../Search/Search-Results';
import CileContentBooks from '../Cile/Cile-Content/Cile-Content-Books';
import CileContentBooksDetails from '../Cile/Cile-Content/Cile-Content-Books-Details';
import CileKits from '../Cile/Cile-Kits';
import VideosHighlightsList from '../Content/Videos/Videos-Highlights-List';
import VideosHighlightsDetails from '../Content/Videos/Videos-Highlights-Details';
import PodcastHighlightsList from '../Content/Podcast/Podcast-Highlights-List';
import PodcastHighlightsDetails from '../Content/Podcast/Podcast-Highlights-Details';
import ProductCileList from '../Cile/Products/Product-List';
import ProductCileDetails from '../Cile/Products/Product-Details';
import HighLightsV2List from '../Content/HighLightsV2/HighLightsV2List';
import HighLightsV2Details from '../Content/HighLightsV2/HighLightsV2Details';
import CileContentEpubDetails from '../Cile/Cile-Content/Cile-Content-Epub-Details';
import CileContentEpubFiles from '../Cile/Cile-Content/Cile-Content-Epub-Files';
import CileContentEpubList from '../Cile/Cile-Content/Cile-Content-Epub-List';
import CileContentEpubReview from '../Cile/Cile-Content/Cile-Content-Epub-Review';
import VideoPlaylistList from '../Content/Playlist/Videos/VideoPlaylistList';
import VideoPlaylistDetails from '../Content/Playlist/Videos/VideoPlaylistDetails';
import PodcastPlaylistList from '../Content/Playlist/Podcast/PodcastPlaylistList';
import PodcastPlaylistDetails from '../Content/Playlist/Podcast/PodcastPlaylistDetails';
import PlaylistTypes from '../Content/Playlist/Playlist-Types';
import SubscriptionCileList from '../Cile/Cile-Subscription/Cile-Subscription-List';
import SubscriptionCileDetails from '../Cile/Cile-Subscription/Cile-Subscription-Details';
import UnlistedContent from '../Content/Unlisted-Content/Unlisted-Content';
import UnlistedArticleDetails from '../Content/Unlisted-Content/Unlisted-Article-Details';
import ArticlePreviewUsers from '../Article-Preview-Users/Article-Preview-Users';

class Logged extends Component {

    constructor() {
        super();
        this.openMenuItem = this.openMenuItem.bind(this);
        this.exibicoesMenu = this.exibicoesMenu.bind(this);
        this.carregaAtendimentos = this.carregaAtendimentos.bind(this);
        this.toggleMenuMobile = this.toggleMenuMobile.bind(this);

        this.configurations = new Configurations();

        this.state = {
            isOpenMenuMobile: false,
            idAtendimentoAtual: null,
            menuItems: [
                // {
                //     name: "Atendimento", icon: "fa-user-friends", childrens: [
                //         { name: "Novo Atendimento", path: "/atendimentos/detalhes/novo-atendimento" },
                //         { name: "Lista de Atendimentos", path: "/atendimentos/lista" },
                //     ], open: false
                // },
                {
                    name: "Cadastros", icon: "fa-id-card", childrens: [
                        { name: "Unificação", path: "/cadastros/unificacao" }
                    ]
                },
                {
                    name: "Pedidos", icon: "fas fa-file-alt", childrens: [
                        { name: "Novo individual", path: "/pedidos/individual" },
                        // { name: "Novo coletivo", path: "/pedidos/coletivo" },
                        { name: "Lista de pedidos", path: "/pedidos/lista" },
                        { name: "Lista de avulsos", path: "/pedidos/avulsos" }
                    ], open: false
                },
                {
                    name: "Campanhas", icon: "fas fa-bullhorn", childrens: [
                        { name: "Lista de campanhas", path: "/campanhas/lista", numPer: 45, visible: false },
                        { name: "Nova campanha", path: "/campanhas/nova", numPer: 45, visible: false },
                    ], open: false
                },
                {
                    name: "Usuários", path: "/usuarios", icon: "fas fa-users", open: false, childrens: [
                        { name: "Lista de usuários", path: "/usuarios" },
                    ]
                },
                {
                    name: "Usuários especiais", path: "/usuarios-especiais", icon: "far fa-id-card", open: false, childrens: [
                        { name: "Lista de usuários especiais", path: "/usuarios-especiais/lista" },
                    ]
                },
                {
                    name: "Conteúdo", icon: "fas fa-pen", childrens: [
                        { name: "BS", path: "/conteudo/bs?pagina=1&limite=10", numPer: 5, visible: false },
                        { name: "Guia para a Vitória", path: "/v2/conteudo/gpv?pagina=1&limite=10", numPer: 5, visible: false },
                        { name: "Juventude Soka", path: "/v2/conteudo/juventude-soka?pagina=1&limite=10", numPer: 8, visible: false },
                        { name: "Liga Monarca", path: "/v2/conteudo/liga-monarca?pagina=1&limite=10", numPer: 8, visible: false },
                        { name: "BJ", path: "/conteudo/bj?pagina=1&limite=10", numPer: 28, visible: false },
                        { name: "TC", path: "/conteudo/tc?pagina=1&limite=10", numPer: 6, visible: false },
                        { name: "RDez", path: "/conteudo/rd?pagina=1&limite=10", numPer: 7, visible: false },
                        { name: "BS+ app", path: "/conteudo/bm/artigos?pagina=1&limite=10", numPer: 8, visible: false },
                        { name: "Frase do Dia", path: "/frase-do-dia/lista?pagina=1&limite=10", numPer: 13, visible: false },
                        { name: "Vídeos", path: "/multimidia/videos?pagina=1&limite=10", numPer: 10, visible: false },
                        { name: "Podcasts", path: "/multimidia/podcasts?pagina=1&limite=10", numPer: 11, visible: false },
                        { name: "Playlists", path: "/multimidia/playlist", numPer: 41, visible: false },
                        { name: "Áreas Especiais", path: "/areas-especiais", numPer: 12, visible: false },
                        { name: "Destaques", path: "/v2/destaques/lista", numPer: 20, visible: false },
                        { name: "Respostas Rápidas", path: "/resposta-rapida/lista", numPer: 33, visible: false },
                        { name: "Termos equivalentes", path: "/pesquisa/lista", numPer: 33, visible: false },
                        { name: "Termos mais pesquisados", path: "/pesquisa/resultados", numPer: 33, visible: false },
                        { name: "Banners", path: "/destaques/banners", numPer: 20, visible: false },
                        { name: "Não Listados", path: "/nao-listados", numPer: 44, visible: false },
                        { name: "Acesso a Previews", path: "/preview-artigos/usuarios", numPer: 46, visible: false },
                    ], open: false
                },
                {
                    name: "Edições", childrens: [
                        { name: "Gerenciamento", path: "/edicoes/lista" }
                    ]
                },
                // {
                //     name: "Produtos", icon: "fa-newspaper", childrens: [
                //         { name: "Lista de Produtos", path: "/produtos/lista" },
                //         { name: "Estoque", path: "/produtos/estoque" },
                //     ], open: false
                // },
                {
                    name: "Coordenadores de Periódicos", icon: "fas fa-sitemap", childrens: [
                        { name: "Lista de Coordenadores", path: "/coordenadores-periodicos", numPer: 17, visible: false },
                    ], open: false
                },
                {
                    name: "Relatórios", icon: "fa-file-contract", childrens: [
                        { name: "Nominal", path: "/relatorios/pedidos/nominal", numPer: 18, visible: false },
                    ], open: false
                },
                {
                    name: "Logística", icon: "fa-truck", childrens: [
                        { name: "Nova remessa", path: "/logistica/remessas/nova" },
                        { name: "Lista de remessas", path: "/logistica/remessas" },
                        // { name: "Lista de remessas - (Correios-individual)", path: "/logistica/remessas/detalhes/:idRemessa/correio-individual" },
                        { name: "Locais de entrega", path: "/logistica/locais-entrega" },
                        { name: "Transportadoras", path: "/logistica/transportadoras" },
                        { name: "Saída de remessa", path: "/logistica/saida-remessa" },
                        { name: "Lista de não-roteirizados", path: "/logistica/lista-nao-roteirizados" }

                    ], open: false
                },
                {
                    name: "Cile", icon: "fa-book-reader", childrens: [
                        { name: "CILE - Pedidos", path: "/cile/pedidos/lista", numPer: 3, visible: false },
                        { name: "CILE - Remessas", path: "/cile/remessas", numPer: 3, visible: false },
                        // { name: "CILE - Executivo", path: "/cile/relatorios/executivo", numPer: 26, visible: false },
                        { name: "CILE - Conteúdo", path: "/cile/conteudo", numPer: 34, visible: false },
                        { name: "CILE - Kits", path: "/cile/kits", numPer: 37, visible: false },
                        { name: "CILE - Lista de produtos", path: "/cile/produtos/lista?pagina=1&limite=10", numPer: 38, visible: false },
                        { name: "CILE - Assinaturas", path: "/cile/assinaturas/lista", numPer: 43, visible: false },
                        { name: "CILE - EPUBs", path: "/cile/conteudo/epub/lista?pagina=1", numPer: 42, visible: false },
                        { name: "CILE - Fila Betalabs", path: "/cile/betalabs/fila", numPer: 40, visible: false },


                    ],
                    open: false
                },
                {
                    name: "Faturamento", icon: "fas fa-file-invoice-dollar", open: false, childrens: [
                        { name: "Lista de Erros", path: "/faturamento/lista-erros" },
                        { name: "Lista de Processados", path: "/faturamento/lista-processados" },
                    ]
                },
                // {
                //     name: "Painel de KPIs", icon: "fa-regular fa-chart-line", open: false, childrens: [
                //         { name: "KPIs", path: "/kpis" }
                //     ]
                // },
                {
                    name: "Perfil", icon: "fas fa-user-cog", open: false, childrens: [
                        { name: "Alterar minha senha", path: "/alterar-senha" }
                    ]
                },
            ]
        }
    }

    // componentDidMount() {
    //     console.log("****DID MOUNT");
    //     const _arrPerm = Usuario.getLoggedUser.permissoes.map(item => item.numero);

    //     const _flagAtendimento = _arrPerm.some(item => item === 1 || item === 2 || item === 4)
    //     this.setState({ flagAtendimento: _flagAtendimento })

    //     // // if (_flagAtendimento) this.carregaAtendimentos();
    // }

    carregaAtendimentos() {
        axios.get(this.configurations.apiBasePath + `/atendimentos/abertos?listaStatusAtendimento=2,3`).then(response => {
            this.setAtendimentosMenu(response.data.atendimentos, null);
            const _atendimentosMenu = this.getAtendimentosMenu();
            this.setState({ atendimentosMenu: _atendimentosMenu })
        }).catch(err => console.log(err))
    }

    componentWillMount() {
        this.openMenuItem(0);
    }

    exibicoesMenu(_paginas, _arrPerm) {
        if (
            _arrPerm.indexOf(1) >= 0 //admin
            || _arrPerm.indexOf(14) >= 0 //supConteudo
            // || _arrPerm.indexOf(20) >= 0 //destaques
            || _arrPerm.indexOf(15) >= 0 //supFinanceiro
            || _arrPerm.indexOf(16) >= 0 //supAtendimento
        )
            return _paginas;

        if (_paginas.filter(item => item.name === "Cile").length > 0) {
            const menu = _paginas.filter(item => item.name === "Cile")[0].childrens.map(item => item.numPer);
            const menuVisivel = menu.filter(item => _arrPerm.indexOf(item) >= 0);

            const novoChildrensConteudo = _paginas.filter(item => item.name === "Cile")[0].childrens.filter(item => menuVisivel.indexOf(item.numPer) >= 0);

            _paginas.filter(item => item.name === "Cile")[0].childrens = novoChildrensConteudo;
        }
        if ((_paginas.filter(item => item.name === "Conteúdo").length > 0) && _arrPerm.indexOf(24) >= 0) {
            const baseAllowed = [5, 6, 7, 8, 10, 11, 41];
            
            const allContentPermissions = _paginas.filter(item => item.name === "Conteúdo")[0].childrens.map(child => child.numPer);
            
            const userContentPermissions = allContentPermissions.filter(numPer => _arrPerm.indexOf(numPer) >= 0);
            
            const allowed = [...new Set([...baseAllowed, ...userContentPermissions])];
            
            const menu = _paginas.filter(item => item.name === "Conteúdo")[0].childrens.filter(p => allowed.indexOf(p.numPer) >= 0).map(i => i.numPer)
            const menuVisivel = menu;
            const novoChildrensConteudo = _paginas.filter(item => item.name === "Conteúdo")[0].childrens.filter(item => menuVisivel.indexOf(item.numPer) >= 0);

            _paginas.filter(item => item.name === "Conteúdo")[0].childrens = novoChildrensConteudo;
            return _paginas;
        }
        else if (_paginas.filter(item => item.name === "Conteúdo").length > 0) {
            const menu = _paginas.filter(item => item.name === "Conteúdo")[0].childrens.map(item => item.numPer);
            const menuVisivel = menu.filter(item => _arrPerm.indexOf(item) >= 0);

            const novoChildrensConteudo = _paginas.filter(item => item.name === "Conteúdo")[0].childrens.filter(item => menuVisivel.indexOf(item.numPer) >= 0);

            _paginas.filter(item => item.name === "Conteúdo")[0].childrens = novoChildrensConteudo;
            return _paginas;
        }
        else return _paginas;
    }

    openMenuItem(index) {
        const user = Usuario.getLoggedUser;
        const arrayPermissoes = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        const paginas = this.state.menuItems.filter(pagina => {
            return Permissions.checkPermission(user.permissoes, pagina.name.toLowerCase())
        });
        this.setState({
            menuItems: update(this.exibicoesMenu(paginas, arrayPermissoes), { [index]: { open: { $set: !this.state.menuItems[index].open } } }),
        })
    }

    toggleMenuMobile() {
        this.setState({ isOpenMenuMobile: !this.state.isOpenMenuMobile })
    }

    render() {
        // const NewAtt = Authorization([Permissions.ATENDIMENTO, Permissions.ADMIN, Permissions.SUPERVISOR]);
        const NewOrd = Authorization([Permissions.ATENDIMENTO, Permissions.ADMIN, Permissions.SUPERVISOR, Permissions.SUPATENDIMENTO]);
        const Orders = Authorization([Permissions.ATENDIMENTO, Permissions.ADMIN, Permissions.SUPERVISOR, Permissions.SUPATENDIMENTO, Permissions.SUPFINANCEIRO]);
        // const CileOrders = Authorization([Permissions.ATENDIMENTO, Permissions.ADMIN, Permissions.SUPERVISOR, Permissions.SUPATENDIMENTO, Permissions.SUPFINANCEIRO]);
        const Logistic = Authorization([Permissions.LOGISTICA, Permissions.ADMIN, Permissions.SUPERVISOR, Permissions.SUPATENDIMENTO]);
        const Content = Authorization([Permissions.EDITORBS, Permissions.EDITORBJ, Permissions.EDITORTC, Permissions.EDITORRD, Permissions.EDITORBM, Permissions.ADMIN, Permissions.SUPCONTEUDO, Permissions.DESTAQUES, Permissions.ESTATISTICA, Permissions.PLAYLISTS]);
        const Products = Authorization([Permissions.ADMIN]);
        const Users = Authorization([Permissions.ADMIN]);
        const Relatorios = Authorization([Permissions.ADMIN, Permissions.RELATORIOS]);
        // const Reports = Authorization([Permissions.ADMIN, Permissions.SUPERVISOR, Permissions.SUPATENDIMENTO, Permissions.SUPFINANCEIRO]);
        const PeriodicalCoord = Authorization([Permissions.ADMIN, Permissions.COORDPERIODICO]);
        const Phrase = Authorization([Permissions.ADMIN, Permissions.SUPERVISOR, Permissions.SUPCONTEUDO, Permissions.FRASEDODIA]);
        const Billing = Authorization([Permissions.ADMIN, Permissions.SUPERVISOR, Permissions.FATURAMENTO, Permissions.SUPFINANCEIRO]);
        const PushNotifications = Authorization([Permissions.ADMIN, Permissions.NOTIFICACOESPUSH]);
        const Campaigns = Authorization([Permissions.ADMIN, Permissions.NOTIFICACOESPUSH]);
        return (
            <div className="container-fluid">
                <div className="row bg-white fixed-top ebs-row-header">
                    <div className="col-12">
                        <Header logo={logo} logout={this.props.logout} isOpenMenuAcessoRapido={false} toggleMenuMobile={this.toggleMenuMobile} isOpenMenuMobile={this.state.isOpenMenuMobile} />
                    </div>
                </div>
                <div className="row bg-white main-area">
                    {/* <div className={`col-${openMenuAcessoRapido ? '1' : '2'} d-none d-md-block px-0`}>
                        <SideBar menuItems={this.state.menuItems} openMenuItem={this.openMenuItem} isOpenMenuAcessoRapido={false} />
                    </div> */}
                    <div className={`col-2 d-none d-md-block px-0`}>
                        <SideBar menuItems={this.state.menuItems} openMenuItem={this.openMenuItem} isOpenMenuAcessoRapido={false} />
                    </div>
                    <div className={`ebs-menu-mobile d-md-none ${this.state.isOpenMenuMobile ? "opened" : ""}`}>
                        <div className="col-12">
                            <MenuMobile
                                menuItems={this.state.menuItems}
                                openMenuItem={this.openMenuItem}
                                toggleMenuMobile={this.toggleMenuMobile}
                            />
                        </div>
                    </div>
                    {/* <div className={`col-12 col-md-${openMenuAcessoRapido ? '9 open-menu' : '10'} bg-gray ebs-content`}> */}


                    <div className={`col-12 col-md-10 bg-gray ebs-content`}>
                        <Route exact strict path="/" component={Home} />
                        <Route exact strict path="/cadastros/unificacao" component={Unification} />

                        <Route exact strict path="/pedidos/individual" component={NewOrd(NewOrder)} />
                        <Route exact strict path="/pedidos/lista" component={Orders(OrdersList)} />
                        <Route exact strict path="/pedidos/avulsos" component={Orders(SingleOrders)} />
                        <Route exact strict path="/assinante/:idUsuario" component={Orders(ClientOrders)} />
                        <Route exact strict path="/pedidos/detalhes/:idPedido" component={Orders(OrderDetails)} />
                        {/* <Route exact strict path="/pedidos/detalhes/:idPedido" component={OrderDetails} /> */}
                        <Route exact strict path="/relatorios/pedidos/nominal" component={Relatorios(Nominal)} />
                        <Route exact strict path="/coordenadores-periodicos" component={PeriodicalCoord(PeriodicalCoordinators)} /> 
                        <Route exact strict path="/logistica/saida-remessa" component={Logistic(ShippingDispatch)} />
                        <Route exact strict path="/logistica/remessas" component={Logistic(ShippingList)} />
                        <Route exact strict path="/logistica/remessas/nova" component={Logistic(NewShipping)} />
                        {/* <Route exact strict path="/logistica/remessas/detalhes/:idRemessa/correio-individual" component={Logistic(ShippingDetailsCorreioIndividual)} /> */}

                        <Route exact strict path="/logistica/remessa/:idRemessa" component={Logistic(ShippingDetails)} />
                        <Route exact strict path="/logistica/locais-entrega" component={Logistic(LocationList)} />
                        <Route exact strict path="/logistica/locais-entrega/detalhes/:idLocal/organizacoes" component={Logistic(LocationInfoOrganizations)} />
                        <Route exact strict path="/logistica/locais-entrega/detalhes/:idLocal/assinantes" component={Logistic(LocationInfoClients)} />
                        <Route exact strict path="/logistica/locais-entrega/detalhes/:idLocal" component={Logistic(LocationInfo)} />
                        <Route exact strict path="/logistica/locais-entrega/novo" component={Logistic(NewLocation)} />
                        <Route exact strict path="/logistica/transportadoras" component={Logistic(CarriersList)} />
                        <Route exact strict path="/logistica/lista-nao-roteirizados" component={Logistic(NotScriptedList)} />

                        <Route exact strict path="/areas-especiais" component={AreasList} />
                        <Route exact strict path="/areas-especiais/:idAreaEspecial" component={AreaDetails} />
                        <Route exact strict path="/multimidia/podcasts" component={PodcastProgramsList} />
                        <Route exact strict path="/multimidia/podcasts/:idPodcastPrograma" component={PodcastProgramsDetails} />
                        <Route exact strict path="/multimidia/podcasts/:idPodcastPrograma/:idPodcastEpisodio" component={PodcastEpisodeDetails} />
                        <Route exact strict path="/multimidia/destaques/podcasts" component={PodcastHighlightsList} />
                        <Route exact strict path="/multimidia/destaques/podcasts/detalhes/:idPodcastEpisodio" component={PodcastHighlightsDetails} />
                        <Route exact strict path="/multimidia/destaques/podcasts/novo" component={PodcastHighlightsDetails} />
                        <Route exact strict path="/multimidia/videos" component={VideosProgramsList} />
                        <Route exact strict path="/multimidia/videos/:idVideoPrograma" component={VideosProgramDetails} />
                        <Route exact strict path="/multimidia/videos/:idVideoPrograma/:idVideoEpisodio" component={VideosEpisodeDetails} />
                        <Route exact strict path="/multimidia/destaques/videos" component={VideosHighlightsList} />
                        <Route exact strict path="/multimidia/destaques/videos/detalhes/:idVideoEpisodio" component={VideosHighlightsDetails} />
                        <Route exact strict path="/multimidia/destaques/videos/novo" component={VideosHighlightsDetails} />
                        <Route exact strict path="/multimidia/playlist" component={PlaylistTypes} />
                        <Route exact strict path="/multimidia/playlist/videos/lista" component={VideoPlaylistList} />
                        <Route exact strict path="/multimidia/playlist/videos/detalhes/:idPlaylist" component={VideoPlaylistDetails} />
                        <Route exact strict path="/multimidia/playlist/podcasts/lista" component={PodcastPlaylistList} />
                        <Route exact strict path="/multimidia/playlist/podcasts/detalhes/:idPlaylist" component={PodcastPlaylistDetails} />
                        <Route exact strict path="/publicidades" component={AdvertisingList} />
                        <Route exact strict path="/publicidades/:idAnuncio" component={AdvertisingDetails} />
                        <Route exact strict path="/v2/conteudo/:periodico" component={Content(ContentEditionList)} />

                        <Route exact strict path="/v2/conteudo/:periodico/:numEdicao" component={Content(ContentEditionDetails)} />
                        <Route exact strict path="/nao-listados" component={UnlistedContent} />
                        <Route exact strict path="/nao-listados/:idArtigo" component={UnlistedArticleDetails} />
                        <Route exact strict path="/preview-artigos/usuarios" component={ArticlePreviewUsers} />
                        <Route exact strict path="/conteudo/:periodico" component={Content(EditionList)} />
                        <Route exact strict path="/conteudo/:periodico/:numEdicao" component={Content(EditionDetails)} />
                        {/* <Route exact strict path="/conteudo/:periodico/:numEdicao" component={EditionDetails} /> */}
                        <Route exact strict path="/conteudo/:periodico/:numEdicao/:idArtigo" component={Content(ArticleDetails)} />
                        <Route exact strict path="/v2/conteudo/:periodico/:numEdicao/:idArtigo" component={Content(ArticleDetails)} />
                        <Route exact strict path="/edicoes/lista" component={EditionsListRegister} />

                        <Route exact strict path="/usuarios" component={Users(UsersList)} />
                        <Route exact strict path="/alterar-senha" component={ChangePassword} />
                        <Route exact strict path="/produtos/lista" component={Products(ProductList)} />
                        <Route exact strict path="/produtos/detalhes/:idProduto" component={Products(ProductDetails)} />
                        <Route exact strict path="/frase-do-dia/lista" component={Phrase(PhrasesList)} />
                        <Route exact strict path="/frase-do-dia/detalhes/:idFrase" component={Phrase(PhraseDetails)} />
                        <Route exact strict path="/faturamento/lista-erros" component={Billing(BillingErrorList)} />
                        <Route exact strict path="/faturamento/lista-processados" component={Billing(BillingProcessedList)} />
                        <Route exact strict path="/atendimentos/lista" component={(ListaAtendimentos)} />
                        <Route exact strict path="/atendimentos/detalhes/:idAtendimento" component={NovoAtendimento} />
                        <Route exact strict path="/permissao-negada" component={PermissaoNegada} />
                        <Route exact strict path="/notificacoes/teste-push" component={PushNotifications(PushTest)} />
                        <Route exact strict path="/campanhas/lista" component={Campaigns(CampaignsList)} />
                        <Route exact strict path="/campanhas/nova" component={Campaigns(CampaignCreate)} />
                        <Route exact strict path="/destaques/lista" component={(HighLights)} />
                        <Route exact strict path="/v2/destaques/lista" component={(HighLightsV2List)} />
                        <Route exact strict path="/v2/destaques/detalhes/:idDestaque" component={(HighLightsV2Details)} />
                        <Route exact strict path="/usuarios-especiais/detalhes/:idEstrangeiro" component={(ForeignersDetails)} />
                        <Route exact strict path="/usuarios-especiais/lista" component={(ForeignersList)} />
                        <Route exact strict path="/assinante/saldo-migracao/:idUsuario" component={(UserBalanceDetails)} />
                        <Route exact strict path="/destaques/destaques-periodico/:periodico" component={(PeriodicalHighlights)} />
                        <Route exact strict path="/cile/pedidos/lista" component={(CileOrdersList)} />
                        <Route exact strict path="/cile/remessas" component={(CileShipping)} />
                        <Route exact strict path="/cile/remessas/detalhes/:idRemessa" component={(CileShippingDetails)} />
                        <Route exact strict path="/cile/relatorios/executivo" component={(CileExecutiveReport)} />
                        {/* <Route exact strict path="/kpis" component={(Kpis)} /> */}
                        <Route exact strict path="/cile/conteudo" component={(CileContent)} />
                        <Route exact strict path="/cile/conteudo/banners" component={(CileContentBanners)} />
                        <Route exact strict path="/cile/conteudo/banners/detalhes/:idBanner" component={(CileContentBannersDetails)} />
                        <Route exact strict path="/cile/conteudo/banners/novo-banner" component={(CileContentBannersDetails)} />
                        <Route exact strict path="/cile/conteudo/videos" component={(CileContentVideos)} />
                        <Route exact strict path="/cile/conteudo/videos/novo-video" component={(CileContentVideosDetails)} />
                        <Route exact strict path="/cile/conteudo/videos/detalhes/:idVideo" component={(CileContentVideosDetails)} />
                        <Route exact strict path="/cile/conteudo/resenhas" component={(CileContentReview)} />
                        <Route exact strict path="/cile/conteudo/livros" component={(CileContentBooks)} />
                        <Route exact strict path="/cile/conteudo/livros/detalhes/:idLivro" component={(CileContentBooksDetails)} />
                        <Route exact strict path="/cile/conteudo/epub/detalhes/:idLivro" component={(CileContentEpubDetails)} />
                        <Route exact strict path="/cile/conteudo/epub/detalhes/arquivos/:idLivro" component={(CileContentEpubFiles)} />
                        <Route exact strict path="/cile/conteudo/epub/lista" component={(CileContentEpubList)} />
                        <Route exact strict path="/cile/conteudo/epub/detalhes/geracao/:idLivro" component={(CileContentEpubReview)} />
                        <Route exact strict path="/cile/conteudo/resenhas/nova-resenha" component={(CileContentReviewDetails)} />
                        <Route exact strict path="/cile/conteudo/resenhas/detalhes/:idResenha" component={(CileContentReviewDetails)} />
                        <Route exact strict path="/cile/kits" component={(CileKits)} />
                        <Route exact strict path="/cile/produtos/lista" component={(ProductCileList)} />
                        <Route exact strict path="/cile/produtos/detalhes/:idProduto" component={(ProductCileDetails)} />
                        <Route exact strict path="/cile/assinaturas/lista" component={(SubscriptionCileList)} />
                        <Route exact strict path="/cile/assinaturas/detalhes/:idAssinatura" component={(SubscriptionCileDetails)} />
                        <Route exact strict path="/cile/betalabs/fila" component={(CileBetalabsFila)} />
                        <Route exact strict path="/cile/betalabs/fila/novo-agendamento" component={(CileBetalabsFilaDetails)} />
                        <Route exact strict path="/cile/betalabs/fila/detalhes" component={(CileBetalabsFilaDetails)} />
                        <Route exact strict path="/resposta-rapida/lista" component={(AnswerList)} />
                        <Route exact strict path="/resposta-rapida/detalhes/:idResposta" component={(AnswerDetails)} />
                        <Route exact strict path="/resposta-rapida/nova-resposta" component={(NewAnswer)} />
                        <Route exact strict path="/pesquisa/lista" component={(SearchList)} />
                        <Route exact strict path="/pesquisa/detalhes/:idPesquisa" component={(SearchDatails)} />
                        <Route exact strict path="/pesquisa/nova-palavra" component={(SearchDatails)} />
                        <Route exact strict path="/pesquisa/resultados" component={(SearchResults)} />
                        <Route exact strict path="/destaques/banners" component={Banners} />
                        <Route exact strict path="/destaques/banners/detalhes/:idBanner" component={BannerDetails} />
                        <Route exact strict path="/destaques/banners/novo-banner" component={BannerDetails} />

                    </div>
                    {/* {
                        (this.state.flagAtendimento && openMenuAcessoRapido) && (
                            <div className="col-2 ebs-menu-acesso-rapido">
                                {tipoMenu === "atendimento" && (
                                    <MenuAtendimento idAtendimento={idAtendimentoAtual} />
                                )}
                                {tipoMenu === "pedido" && (
                                    <MenuPedido idPedido={idPedidoAtual} />
                                )}
                            </div>
                        )
                    } */}
                </div>
            </div>
        )
        // return (
        //     <>
        //         <Consumer>
        //             {({ setAtendimentosMenu, getAtendimentosMenu, openMenuAcessoRapido, idAtendimentoAtual, idPedidoAtual, tipoMenu, setTipoMenu }) => {
        //                 this.setAtendimentosMenu = setAtendimentosMenu;
        //                 this.getAtendimentosMenu = getAtendimentosMenu;

        //             }
        //             }
        //         </Consumer >
        //     </>
        // )
    }
}

export default Logged;
